/**
@description : Checking value is valid or not
*/

import axios from "axios";
const qs = require("qs");

const isValid = (value) => {
  if (
    value !== undefined &&
    value !== "" &&
    value !== null &&
    value.length > 0
  ) {
    return true;
  } else {
    return false;
  }
};

const sharedAxiosAPI = (
  URL = null,
  ContentType = { "Content-Type": "application/x-www-form-urlencoded" },
  data = {},
  qsArrayFormat = null,
) => {
  let userId = localStorage.getItem("userId");
  let token = localStorage.getItem("token");
  const requestParams = {
    auth_key: token,
    user_id: userId,
  };
  var requestData = {
    auth_key: token,
    user_id: userId,
    ...data,
  };

  return axios.post(URL, qs.stringify(requestData, qsArrayFormat), {
    headers: ContentType,
    params: requestParams,
  });
};

//without data parameter

const sharedAxiosAPISpringesc = (
  URL = null,
  ContentType = { "Content-Type": "application/x-www-form-urlencoded" },
  data = {},
  qsArrayFormat = null,
) => {
  let userId = localStorage.getItem("userId");
  let token = localStorage.getItem("springToken");
  const requestParams = {
    auth_key: token,
    user_id: userId,
    ...data,
  };
  var requestData = {
    auth_key: token,
    user_id: userId,
    ...data,
  };

  return axios.post(URL, null, {
    headers: ContentType,
    params: requestParams,
  });
};

const sharedAxiosAPISpring = (
  URL = null,
  ContentType = { "Content-Type": "application/x-www-form-urlencoded" },
  data = {},
  qsArrayFormat = null,
) => {
  let userId = localStorage.getItem("userId");
  let token = localStorage.getItem("springToken");
  const requestParams = {
    auth_key: token,
    user_id: userId,
  };
  var requestData = {
    auth_key: token,
    user_id: userId,
    ...data,
  };

  return axios.post(URL, qs.stringify(requestData, qsArrayFormat), {
    headers: ContentType,
    params: requestParams,
  });
};

const sharedAxiosAPISpringWithoutParam = (
  URL = null,
  ContentType = { "Content-Type": "application/x-www-form-urlencoded" },
  data = {},
  qsArrayFormat = null,
) => {
  return axios.post(
    URL,
    {},
    {
      headers: ContentType,
    },
  );
};

const sharedAxiosAPInew = (
  URL = null,
  ContentType = { "Content-Type": "application/json" },
  data = {},
) => {
  let userId = localStorage.getItem("userId");
  let token = localStorage.getItem("springToken");
  const requestParams = {
    auth_key: token,
    user_id: userId,
  };

  var requestData = {
    auth_key: token,
    user_id: userId,
    ...data,
  };

  return axios.post(URL, requestData, {
    params: requestParams,
    headers: ContentType,
    validateStatus: function (status) {
      // Accept all status codes from 200 to 499 as "valid" responses
      return status >= 200 && status < 500;
    },
  });
};

const sharedAxiosAPIPostParams = (
  URL = null,
  ContentType = { "Content-Type": "application/json" },
  data = {},
) => {
  let userId = localStorage.getItem("userId");
  let token = localStorage.getItem("springToken");
  const requestParams = {
    auth_key: token,
    user_id: userId,
    ...data,
  };

  var requestData = {
    auth_key: token,
    user_id: userId,
    ...data,
  };

  return axios.post(URL, requestData, {
    params: requestParams,
    headers: ContentType,
    validateStatus: function (status) {
      // Accept all status codes from 200 to 499 as "valid" responses
      return status >= 200 && status < 500;
    },
  });
};

const sharedAxiosAPInewRR = (
  URL = null,
  ContentType = { "Content-Type": "application/json" },
  data = {},
) => {
  let userId = localStorage.getItem("userId");
  let token = localStorage.getItem("springToken");
  const requestParams = {
    auth_key: token,
    user_id: userId,
  };

  var requestData = {
    auth_key: token,
    user_id: Number(userId),
    ...data,
  };

  return axios.post(URL, requestData, {
    // params:requestParams,
    headers: ContentType,
    validateStatus: function (status) {
      // Accept all status codes from 200 to 499 as "valid" responses
      return status >= 200 && status < 500;
    },
  });
};

const sharedAxiosAPIupdate = (
  URL = null,
  ContentType = { "Content-Type": "application/json" },
  data = {},
) => {
  let userId = localStorage.getItem("userId");
  let token = localStorage.getItem("springToken");
  const requestParams = {
    auth_key: token,
    user_id: userId,
  };

  var requestData = {
    ...data,
  };

  return axios.put(URL, requestData, {
    params: requestParams,
    headers: ContentType,
    validateStatus: function (status) {
      // Accept all status codes from 200 to 499 as "valid" responses
      return status >= 200 && status < 500;
    },
  });
};
const sharedAxiosAPINew = (
  URL = null,
  ContentType = { "Content-Type": "application/json" },
  data = null,
) => {
  let userId = localStorage.getItem("userId");
  let token = localStorage.getItem("springToken");
  const requestParams = {
    auth_key: token,
    user_id: userId,
  };

  if (data) {
    // If data exists, use POST
    var requestData = {
      ...data,
    };

    return axios.post(URL, requestData, {
      params: requestParams,
      headers: ContentType,
    });
  } else {
    // If no data, assume GET
    return axios.delete(URL, {
      params: requestParams,
      headers: ContentType,
    });
  }
};
const sharedAxiosAPIRestore = (
  URL = null,
  ContentType = { "Content-Type": "application/json" },
  data = null,
) => {
  let userId = localStorage.getItem("userId");
  let token = localStorage.getItem("springToken");
  const requestParams = {
    auth_key: token,
    user_id: userId,
  };

  return axios.put(
    URL,
    {},
    {
      params: requestParams,
      headers: ContentType,
    },
  );
};
const sharedAxiosAPIGet = (
  URL = null,
  params = {},
  ContentType = { "Content-Type": "application/json" },
  data = null,
) => {
  let userId = localStorage.getItem("userId");
  let token = localStorage.getItem("token");

  const requestParams = {
    auth_key: token,
    user_id: userId,
    ...params,
  };

  return axios.get(URL, {
    params: requestParams,
    headers: ContentType,
  });
};

const sharedAxiosGETAPI = (
  URL = null,
  params = {},
  ContentType = { "Content-Type": "application/json" },
) => {
  let userId = localStorage.getItem("userId");
  let token = localStorage.getItem("springToken");

  const requestParams = {
    auth_key: token,
    user_id: userId,
    page: 0,
    size: 1000,
    ...params,
  };

  const headers = {
    accept: "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
    ...ContentType,
  };

  return axios.get(URL, {
    params: requestParams,
    headers: headers,
  });
};
const sharedAxiosGETAPISpring = (
  URL = null,
  params = {
    auth_key: localStorage.getItem("springToken"),
    user_id: localStorage.getItem("userId"),
  },
  ContentType = { "Content-Type": "application/json" },
) => {
  let userId = localStorage.getItem("userId");
  let token = localStorage.getItem("springToken");

  const requestParams = {
    auth_key: token,
    user_id: userId,
    ...params,
  };

  return axios.get(URL, {
    params: requestParams,
    headers: ContentType,
  });
};
const sharedAxiosGETAPIForRR = (
  URL = null,
  params = {},
  ContentType = { "Content-Type": "application/json" },
) => {
  let userId = localStorage.getItem("userId");
  let token = localStorage.getItem("springToken");

  const requestParams = {
    // auth_key: token,
    userId: userId,
    ...params,
  };

  return axios.get(URL, {
    params: requestParams,
    headers: ContentType,
  });
};

const sharedAxiosGETAPIRR = (
  URL = null,
  params = {},
  ContentType = { "Content-Type": "application/json" },
) => {
  let userId = localStorage.getItem("userId");
  let token = localStorage.getItem("springToken");

  const requestParams = {
    user_id: userId,
    ...params,
  };

  return axios.get(URL, {
    params: requestParams,
    headers: ContentType,
  });
};

const checkPermittedRoute = (routeList, checkingRoute) => {
  const searchModule = checkingRoute.toLowerCase().trim();
  // console.log("searchModule === " +searchModule);
  // console.log("routeList ==== "+routeList);
  const find = routeList.find(
    (listItem) => listItem?.module_name?.trim().toLowerCase() == searchModule,
  );
  return find == undefined ? false : true;
};

const urlBuilder = (str = "") => {
  var re = new RegExp("^(http|https)://", "i");
  if (re.test(str)) {
    return str;
  }
  return `https://${str}`;
};

const validateNumber = (e, length = 10) => {
  const value = e.target.value?.replace?.(/[^0-9]/g, "")?.slice?.(0, length);
  e.target.value = value;
};

const validateNumberNeg = (e, length = 10) => {
  let value = e.target.value;

  // Allow negative sign only at the start
  value = value.replace(/(?!^-)[^0-9]/g, "");

  // Limit numeric part (ignore '-' when counting length)
  if (value.startsWith("-")) {
    value = "-" + value.slice(1, length + 1);
  } else {
    value = value.slice(0, length);
  }

  e.target.value = value;
};

const validateCharLimit = (value, limit) => {
  if (value.length > limit) {
    return {
      isValid: false,
      trimmedValue: value.slice(0, limit),
      error: `Maximum ${limit} characters allowed.`,
    };
  }

  return {
    isValid: true,
    trimmedValue: value,
    error: "",
  };
};

const validateDecimal = (
  e,
  maxDigitsBeforeDecimal = 10,
  maxDigitsAfterDecimal = 2,
) => {
  let value = e.target.value;

  // Allow only digits and at most one dot
  value = value.replace(/[^0-9.]/g, "");

  // Prevent more than one decimal point
  const parts = value.split(".");
  if (parts.length > 2) {
    value = parts[0] + "." + parts[1]; // ignore extra dots
  }

  // Limit digits before and after decimal
  const [integerPart, decimalPart] = value.split(".");
  const trimmedInteger = integerPart?.slice(0, maxDigitsBeforeDecimal) || "";
  const trimmedDecimal = decimalPart?.slice(0, maxDigitsAfterDecimal) || "";

  value = trimmedInteger;
  if (decimalPart !== undefined) {
    value += "." + trimmedDecimal;
  }

  e.target.value = value;
};

const lmssharedAxiosAPIpost = (
  URL = null,
  ContentType = { "Content-Type": "application/json" },
  data = {},
) => {
  let userId = localStorage.getItem("userId");
  let token = localStorage.getItem("springToken");
  const requestParams = {
    auth_key: token,
    user_id: userId,
  };

  var requestData = {
    userId: userId,
    ...data,
  };

  return axios.post(URL, requestData, {
    params: requestParams,
    headers: ContentType,
    validateStatus: function (status) {
      // Accept all status codes from 200 to 499 as "valid" responses
      return status >= 200 && status < 500;
    },
  });
};

const lmssharedAxiosAPIupdate = (
  URL = null,
  ContentType = { "Content-Type": "application/json" },
  data = {},
) => {
  let userId = localStorage.getItem("userId");
  let token = localStorage.getItem("springToken");
  const requestParams = {
    auth_key: token,
    user_id: userId,
  };

  var requestData = {
    ...data,
  };

  return axios.put(URL, requestData, {
    params: requestParams,
    headers: ContentType,
  });
};
const lmssharedAxiosAPIDelete = (
  URL = null,
  ContentType = { "Content-Type": "application/json" },
  data = null,
) => {
  let userId = localStorage.getItem("userId");
  let token = localStorage.getItem("springToken");
  const requestParams = {
    auth_key: token,
    user_id: userId,
  };

  if (data) {
    // If data exists, use POST
    var requestData = {
      ...data,
    };

    return axios.post(URL, requestData, {
      params: requestParams,
      headers: ContentType,
    });
  } else {
    // If no data, assume GET
    return axios.delete(URL, {
      params: requestParams,
      headers: ContentType,
    });
  }
};

const lmssharedAxiosGETAPI = (
  URL = null,
  params = {},
  ContentType = { "Content-Type": "application/json" },
) => {
  let userId = localStorage.getItem("userId");
  let token = localStorage.getItem("springToken");

  const requestParams = {
    auth_key: token,
    user_id: userId,
    ...params,
  };

  return axios.get(URL, {
    params: requestParams,
    headers: ContentType,
  });
};

const validateEmail = (email) => {
  const pattern = new RegExp(
    /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
  );
  return pattern.test(email);
};
const formatToTwoDecimalPlaces = (value) => {
  const num = parseFloat(value);
  if (isNaN(num)) return "0.00"; // fallback for invalid input
  return num.toFixed(2);
};

const getDb = () => {
  const hostname = window.location.hostname.toLowerCase();

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "stageclide";
  }

  if (hostname.endsWith(".clideanalyser.in")) {
    const db = hostname.replace(".clideanalyser.in", "").trim();

    if (db === "qaclide") {
      return "stageclide";
    }

    return db;
  }

  return hostname.split(".")[0] || "stageclide";
};

export {
  isValid,
  sharedAxiosGETAPIForRR,
  formatToTwoDecimalPlaces,
  sharedAxiosGETAPISpring,
  sharedAxiosAPISpringesc,
  validateDecimal,
  lmssharedAxiosAPIupdate,
  sharedAxiosAPI,
  lmssharedAxiosAPIDelete,
  sharedAxiosAPInewRR,
  sharedAxiosGETAPIRR,
  lmssharedAxiosGETAPI,
  lmssharedAxiosAPIpost,
  sharedAxiosGETAPI,
  checkPermittedRoute,
  urlBuilder,
  validateNumber,
  sharedAxiosAPIupdate,
  validateEmail,
  sharedAxiosAPInew,
  sharedAxiosAPIPostParams,
  sharedAxiosAPINew,
  sharedAxiosAPIRestore,
  sharedAxiosAPISpring,
  sharedAxiosAPISpringWithoutParam,
  validateCharLimit,
  validateNumberNeg,
  sharedAxiosAPIGet,
  getDb,
};
